import { ChangeDetectorRef, Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { SharerService } from 'src/app/services/sharer.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TaskService } from 'src/app/services/task.service';
import { environment } from 'src/environments/environment';
import { DataTableDirective } from "angular-datatables";
import { Observable, Subject } from 'rxjs';
import { FormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { Globals } from 'src/app/helpers/globals';
import { UpsiMasterService } from 'src/app/services/upsi-master.service';
import { DetailsService } from 'src/app/services/details.service';
import { UpsiemaillogdetailsComponent } from '../upsiemaillogdetails/upsiemaillogdetails.component';
import { AlertComponent } from '../../alert/alert.component';
import { UpsiDetailsService } from 'src/app/services/upsi-details.service';
import { NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { EmailsLogService } from 'src/app/services/emails-log.service';
import { DatePipe } from '@angular/common';



declare var $: any;
declare var jQuery: any;
@Component({
  selector: 'app-upsi-details-list',
  templateUrl: './upsi-details-list.component.html',
  styleUrls: ['./upsi-details-list.component.css'],
  providers: [Globals]

})
export class UpsiDetailsListComponent implements OnInit {
  @ViewChild('dp') dp: any;

  forceOpen() {
    this.cdRef.detectChanges();
    this.dp.open();
  }
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtUpsiDetails: DataTables.Settings = {
    scrollX: true,
    scrollCollapse: true,
    autoWidth: false,
    responsive: false,
  };
  dtUpsiDetailsTrigger: Subject<any> = new Subject();
  dtDetailsHistory: DataTables.Settings = {
    scrollX: true,
    scrollCollapse: true,
    autoWidth: false,
    responsive: false,
  };
  dtDetailsTrigger: Subject<any> = new Subject();
  upsiDetails: any;
  userlistForFilter: any;
  sharerListForFilter: any;
  sharerListForFilterFinal: any;
  recipientListForFilter: any;
  sharerForm: FormGroup;
  detailsHistory: any;
  shareddate: any;
  shareddateTo: any;
  upsidate: any;
  upsidateto: any;
  EnteredBy: '';
  entrydate: any;
  entrydateTo: any;
  Recipient: '';
  sharerBy: '';
  Updatedby: '';
  response: any;
  sharerType: any;
  receipientType: any;
  nonGovSharer: boolean;
  nonGovRecipient: boolean;
  detailsIdforDelete: any;
  ItemList: any;
  debugDate: string;
  Item: any;
  isSearchDivVisible = false;
  fileNameArray: Array<any> = [];
  exportColumnMap: any = [];
  UPSIListexportColumnOrignalOrder: any = [];
  UPSIDetailsListSearchMode: any;
  isShowUnapproved: boolean = false;
  isShowEncryptedPAN: boolean = false;
  isMakerCheckerUsed = environment.IsUPSIMakerCheckerUsed

  public token: any = localStorage.getItem('token')
  public downloadSingleFile: string;
  public downloadURLForUPSIEmail: any = environment.pssServerUrl + "upsi/EmailDoc/";
  public downloadURLForUPSIBase: any = environment.pssServerUrl + "upsi/BaseDoc/";
  public downloadURLForUPSI: any = environment.pssServerUrl + "documentManagement/downloadSingleFileOnID/";
  selectedIds: string[] = [];

  constructor(private config: NgbDatepickerConfig,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private alert: AlertComponent,
    private commonFunction: CommonFunction,
    private renderer: Renderer2,
    private sharerService: SharerService,
    private detailsService: DetailsService,
    private taskService: TaskService,
    public modalService: NgbModal,
    public globals: Globals,
    private upsiMasterService: UpsiMasterService,
    private emailsLogService: EmailsLogService,
    private route: ActivatedRoute, 
    private uPSIDatailsService: UpsiDetailsService,
    private datePipe: DatePipe,
  ) { }

  ngOnInit(): void {
    let selfInstance = this
    this.EnteredBy = '';
    this.Item = '';
    this.Updatedby = '';
    this.Recipient = '';
    this.sharerBy = '';
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var paramData = {
      companyID: companyDetails.companyID
    }
    this.isShowUnapproved = !this.isMakerCheckerUsed; // false;
    this.isShowEncryptedPAN = true;
    this.UPSIDetailsListSearchMode = "both";

    this.exportColumnMap = [
      { "columnName": "Shared by", "columnIndex": 1 },
      { "columnName": "Recipient", "columnIndex": 2 },
      { "columnName": "Nature of UPSI", "columnIndex": 4 },
      { "columnName": "Brief details of UPSI shared", "columnIndex": 5 },
      { "columnName": "Email Text", "columnIndex": 6 },
      { "columnName": "Email Subject", "columnIndex": 7 },
      { "columnName": "Attachment for Email", "columnIndex": 8 },
      { "columnName": "Mode Of Sharing", "columnIndex": 9 },
      { "columnName": "Purpose for Sharing", "columnIndex": 10 },
      { "columnName": "Date Of Initiation", "columnIndex": 11 },
      { "columnName": "Persons in possession of UPSI", "columnIndex": 12 },
      { "columnName": "When UPSI Public/Not Applicable", "columnIndex": 13 },
      { "columnName": "Date of Sharing", "columnIndex": 21 },
      { "columnName": "Time of Sharing", "columnIndex": 22 },
      { "columnName": "Entered by", "columnIndex": 15 },
      { "columnName": "Date of Entry", "columnIndex": 23 },
      { "columnName": "Time of Entry", "columnIndex": 24 },
      { "columnName": "Updated by", "columnIndex": 18 },
      { "columnName": "Date of Updation", "columnIndex": 25 },
      { "columnName": "Time of Updation", "columnIndex": 26 }
    ];

    this.UPSIListexportColumnOrignalOrder = [1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 21, 22, 15, 23, 24, 18, 25, 26];

    this.upsiMasterService.getList(paramData).subscribe((response: any) => {
      if (response.status == 0) {
        this.ItemList = response.data;
      }
    })
    this.downloadSingleFile = environment.pssServerUrl + 'documentManagement/downloadSingleFileOnID/';

    const title = `
      UPSI Details List \n 
      ${companyDetails.companyName}
    `;
    this.dtUpsiDetails = {
      processing: true,
      serverSide: false,
      scrollX: true,
      deferRender: true,
      stateSave: true,
      stateDuration: -1,
      scrollY: "420px",
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      autoWidth: false,
      search: true,
      order: [5, 'desc'],

      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> &nbsp;Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'UPSI Details List',
          title: title,
          extend: 'excel',
          exportOptions: {
            columns: [1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 21, 22, 15, 23, 24, 18, 25, 26],
            format: {
              body: function (data, row, column, node) {
                if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                  if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) {
                    return data
                  }
                  else {
                    return data.replace(/<[^>]*>/g, '');
                    // return  "'" + data + "'"; 
                  }
                } else { return data }
              }
            }
          },
        },
        {
          text: '<i class="fa fa-files-o"></i>&nbsp; Export to PDF',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'UPSI Details List',
          title: title,
          orientation: 'landscape',
          extend: 'pdfHtml5',
          footer: true,
          pageSize: 'A2',
          customize: function (doc) {
            doc['footer'] = (function () {
              return {
                columns: [
                  {
                    alignment: 'center',
                    text: [
                      { text: "This is a system generated report and hence does not require physical signature", italics: true }
                    ]
                  }
                ],
                margin: [10, 0]
              }
            });
          },
          action: function (e, dt, node, config) {
            const upsiDetails = selfInstance.upsiDetails.sort((a, b) => {
              // Handle both timestamp and DD/MM/YYYY format for sorting
              const dateA = selfInstance.parseDate(a.SharedDate);
              const dateB = selfInstance.parseDate(b.SharedDate);
              if (!dateA && !dateB) return 0;
              if (!dateA) return 1;
              if (!dateB) return -1;
              return dateA.getTime() - dateB.getTime();
            });

            let message = "";
            // Use parseDate method to handle DD/MM/YYYY format correctly
            let tempDate = selfInstance.parseDate(upsiDetails.at(0).SharedDate) || new Date()
            let tempDate2 = selfInstance.parseDate(upsiDetails.at(-1).SharedDate) || new Date()

            if (selfInstance.shareddate || selfInstance.shareddateTo) {
              message = "Date when shared:"
              if (selfInstance.shareddate) {
                let { day, month, year } = selfInstance.shareddate
                tempDate = new Date(year, --month, day)
              }

              if (selfInstance.shareddate) {
                let { day, month, year } = selfInstance.shareddateTo
                tempDate2 = new Date(year, --month, day)
              }
            } else if (selfInstance.upsidate || selfInstance.upsidateto) {
              message = "UPSI Public Date:"
              if (selfInstance.upsidate) {
                let { day, month, year } = selfInstance.upsidate
                tempDate = new Date(year, --month, day)
              }

              if (selfInstance.upsidateto) {
                let { day, month, year } = selfInstance.upsidateto
                tempDate2 = new Date(year, --month, day)
              }
            } else if (selfInstance.entrydate || selfInstance.entrydateTo) {
              message = "Date of entry:"
              if (selfInstance.entrydate) {
                let { day, month, year } = selfInstance.entrydate
                tempDate = new Date(year, --month, day)
              }

              if (selfInstance.entrydateTo) {
                let { day, month, year } = selfInstance.entrydateTo
                tempDate2 = new Date(year, --month, day)
              }
            }

            let shareddate = `${tempDate.getDate()}-${tempDate.getMonth() + 1}-${tempDate.getFullYear()}`;
            let shareddateTo = `${tempDate2.getDate()}-${tempDate2.getMonth() + 1}-${tempDate2.getFullYear()}`;
            config.message = `${message}${shareddate} - ${shareddateTo}`
            $.fn.dataTable.ext.buttons.pdfHtml5.action.call(this, e, dt, node, config);
          },
          exportOptions: {
            columns: [0, 1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 21, 22, 15, 23, 24, 18, 25, 26]
          },
        }
      ]

    }


    this.dtDetailsHistory = {
      processing: true,
      serverSide: false,
      scrollX: true,
      deferRender: true,
      stateSave: true,
      stateDuration: -1,
      scrollY: "420px",
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [15, 'desc'],
      columnDefs: [{ width: '100px', targets: [1] }],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i>&nbsp; Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'UPSI Details History List',
          title: 'UPSI Details History List',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21],
            format: {
              body: function (data, row, column, node) {
                if (data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")) {
                  if (data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)) { return data } else { return "'" + data + "'"; }
                } else { return data }
              }
            }
          },
        },
        {
          text: '<i class="fa fa-files-o"></i> &nbsp;Export to PDF',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'UPSI Details History List',
          title: `UPSI Details History List \n ${companyDetails.companyName}`,
          orientation: 'landscape',
          pageSize: 'A2',
          extend: 'pdfHtml5',
          footer: true,
          customize: function (doc) {
            doc['footer'] = (function () {
              return {
                columns: [
                  {
                    alignment: 'center',
                    text: [
                      { text: "This is a system generate report and hence does not require physical signature", italics: true }
                    ]
                  }
                ],
                margin: [10, 0]
              }
            });
          },
          action: function (e, dt, node, config) {
            const upsiDetails = selfInstance.upsiDetails.sort((a, b) => {
              // Handle both timestamp and DD/MM/YYYY format for sorting
              const dateA = selfInstance.parseDate(a.SharedDate);
              const dateB = selfInstance.parseDate(b.SharedDate);
              if (!dateA && !dateB) return 0;
              if (!dateA) return 1;
              if (!dateB) return -1;
              return dateA.getTime() - dateB.getTime();
            });
            // Use parseDate method to handle DD/MM/YYYY format correctly
            let tempDate = selfInstance.parseDate(upsiDetails.at(0).SharedDate) || new Date()
            let tempDate2 = selfInstance.parseDate(upsiDetails.at(-1).SharedDate) || new Date()
            let shareddate = `${tempDate.getDate()}-${tempDate.getMonth() + 1}-${tempDate.getFullYear()}`;
            let shareddateTo = `${tempDate2.getDate()}-${tempDate2.getMonth() + 1}-${tempDate2.getFullYear()}`;
            config.message = `${shareddate} - ${shareddateTo}`
            $.fn.dataTable.ext.buttons.pdfHtml5.action.call(this, e, dt, node, config);
          },
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21]
          },
        }
      ]

    }
    this.getDetailsList({});
    // this.clear();
  }
  ngOnDestroy(): void {
    this.dtUpsiDetailsTrigger.unsubscribe();
  }
  handleCheckboxChange() {
    // this.ngOnInit();
    this.getDetailsList({});
  }
  extractRecipient(str: string): string {
    const match = str.match(/-(\w+)/);
    if (match) {
      const encryptedPan = '**********'; // Your encryption logic here
      return str.replace(match[1], encryptedPan);
    } else {
      return str;
    }
  }

  /**
   * Parses date values from API (DD/MM/YYYY, DD-MM-YYYY, ISO, Date, timestamp)
   * into a Date object for DatePipe compatibility.
   */
  parseDate(value: any): Date | null {
    if (!value || value === 0) return null;
    if (value instanceof Date && !isNaN(value.getTime())) return value;
    if (typeof value === 'number') {
      // Reject 0 or negative timestamps (invalid/not set)
      if (value <= 0) return null;
      const d = new Date(value);
      return isNaN(d.getTime()) ? null : d;
    }
    if (typeof value === 'string' && value.trim() !== '') {
      // DD/MM/YYYY or DD-MM-YYYY (with optional time part)
      const match = value.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?(?:\s*(?:AM|PM|am|pm))?)?/i);
      if (match) {
        const day = parseInt(match[1], 10);
        const month = parseInt(match[2], 10) - 1;
        const year = parseInt(match[3], 10);
        // Reject dates before 1970 (likely indicates 0 timestamp converted to date)
        if (year < 1970) return null;
        let d: Date;
        if (match[4] !== undefined) {
          const h = parseInt(match[4], 10);
          const min = parseInt(match[5], 10);
          const sec = match[6] ? parseInt(match[6], 10) : 0;
          const isPM = /pm/i.test(value);
          let hour = h;
          if (isPM && h < 12) hour = h + 12;
          else if (!isPM && h === 12) hour = 0;
          d = new Date(year, month, day, hour, min, sec);
        } else {
          d = new Date(year, month, day);
        }
        return isNaN(d.getTime()) ? null : d;
      }
      const parsed = new Date(value);
      return isNaN(parsed.getTime()) ? null : parsed;
    }
    return null;
  }

  formatDate(value: any, format: string): string {
    const date = this.parseDate(value);
    if (!date) return '';
    return this.datePipe.transform(date, format) || '';
  }

  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }

  checkAndSetSelectExportColumnsBtnManually(timeout) {
    //checking if the custom button already exists
    //If exists dont add if not there then add
    setTimeout(() => {
      var selectExportColumnsBtn_check = document.getElementById("selectExportColumnsBtn_manual");
      if (!selectExportColumnsBtn_check) {
        var dataTables_butons = $("#UpisDetailsListTable").find("div")[2];

        if (dataTables_butons) {
          const selectExportColumnsBtn = document.createElement("BUTTON");
          //selectExportColumnsBtn.innerText = "Select Export Columns";
          selectExportColumnsBtn.setAttribute("class", "dt-button buttons-excel buttons-html5 btn btn-sm btn-warning export-btn");
          selectExportColumnsBtn.setAttribute("id", "selectExportColumnsBtn_manual");

          const selectExportColumnsSpan = document.createElement("span");
          selectExportColumnsSpan.innerHTML = `<i class="fa fa-filter"></i>&nbsp;Select Export Columns`
          selectExportColumnsBtn.appendChild(selectExportColumnsSpan);


          //UPSIExportColumnSelect
          selectExportColumnsBtn.addEventListener("click", () => {
            $("#UPSIExportColumnSelect").modal('toggle');
          })

          dataTables_butons.appendChild(selectExportColumnsBtn);
        }
      }

    }, timeout);
  }


  ngAfterViewInit() {
    //checkAndSetSelectExportColumnsBtnManually >> will set the custom select columns for export button
    // Sometimes there is a delay in setting up datatables button, hence the custom button is attempted to set 
    // on the time periods of 600, 1200, 2000 milliSeconds.

    this.checkAndSetSelectExportColumnsBtnManually(600);
    this.checkAndSetSelectExportColumnsBtnManually(1200);
    this.checkAndSetSelectExportColumnsBtnManually(2000);
    this.cdRef.detectChanges();
    this.dtUpsiDetailsTrigger.next();
  }


  getDetailsList(paramData) {
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var paramData2 = {
      companyID: companyDetails.companyID
    }

    let sharerList = this.sharerService.getAllSharerList(paramData2);
    let recipientList = this.sharerService.getAllRecipientList(paramData2);
    let detailsList = this.detailsService.getDetailsList(paramData);
    let usersList = this.taskService.getAllUsersList();

    Observable.forkJoin([detailsList, sharerList, recipientList, usersList])
      .subscribe((response: any) => {
        var detailsData;
        if (response[0].status == 0) {
          detailsData = response[0].data
        } else {
          detailsData = {};
        }
        var sharerData;
        if (response[1].status == 0) {
          sharerData = response[1].data;
          this.sharerListForFilter = _.orderBy(sharerData, 'Name', 'asc');
          // console.log('sharerListForFilter', this.sharerListForFilter)
        } else {
          sharerData = {};
        }
        var recipientData;
        if (response[2].status == 0) {
          recipientData = response[2].data;
          let cloneUPSIUser = _.orderBy(recipientData, 'Name', 'asc');
          var cloneOfUserListArrayUpsi = cloneUPSIUser.map(function (element) {
            var o = Object.assign({}, element);

            o.UserType = 'nonGovevaUser';

            return o;
          });
        } else {
          recipientData = {};
        }
        var detailsListData = [];

        var usersData;
        if (response[3].status == 0) {
          usersData = response[3].result;
          this.userlistForFilter = _.orderBy(usersData, 'FirstName', 'asc');
          // console.log('userlistForFilter', this.userlistForFilter)

          // Add Name property to user items for consistent display
          let userListWithName = this.userlistForFilter.map(user => ({
            ...user,
            Name: (user.FirstName || '') + ' ' + (user.LastName || '').trim()
          }));
          this.sharerListForFilterFinal = (this.sharerListForFilter).concat(userListWithName)
          // console.log('sharerListForFilterFinal', this.sharerListForFilterFinal)

          let cloneOfUserList = _.orderBy(usersData, 'FirstName', 'asc');
          var cloneOfUserListArray = [];
          cloneOfUserListArray = cloneOfUserList.map(function (element) {
            var o = Object.assign({}, element);
            o._id = o._id;
            o.Name = o.Title + ' ' + o.FirstName + ' ' + o.LastName;
            o.email_id = o.EmailId;
            o.UserType = 'govevaUser';
            o.IsSelected = o.IsSelected;
            o.Designation = o.Designation;
            o.ContactNumber = o.MobileNumber;
            return o;
          });
        } else {
          usersData = {};
        }

        if (this.dtElement && this.dtElement.dtInstance) {
          this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.destroy();
            this.dtUpsiDetailsTrigger.next();
          });
        } else {
          this.dtUpsiDetailsTrigger.next();
        }


        var self = this

        this.recipientListForFilter = (cloneOfUserListArray).concat(cloneOfUserListArrayUpsi)
        // console.log('recipientListForFilter', this.recipientListForFilter)
        _.forEach(detailsData, function (details) {
          var recipientByName = []

          if (details.SharerType == "nonGovevaUser") {
            var SharerBY = _.filter(sharerData, ["_id", details.SharerId]);
            _.assign(details, { SharerBYName: (SharerBY[0] != null || SharerBY[0] != undefined) ? SharerBY[0].Name : "" })
            _.assign(details, { SharerBYPan: (SharerBY[0] != null || SharerBY[0] != undefined) ? SharerBY[0].Document_No : "" })
          } else {
            var SharerBY = _.filter(usersData, ["_id", details.SharerId]);
            // var decrPan = CryptoJS.AES.decrypt(SharerBY[0].PAN, this.secretKey.trim()).toString(CryptoJS.enc.Utf8);
            // console.log("decrPan",decrPan)
            _.assign(details, { SharerBYName: (SharerBY[0] != null || SharerBY[0] != undefined) ? (SharerBY[0].FirstName + " " + SharerBY[0].LastName) : "" })
            if (SharerBY && SharerBY.length > 0 && SharerBY[0].PAN && SharerBY[0].PAN.length > 10) {
              _.assign(details, { SharerBYPan: self.commonFunction.decrypt(SharerBY[0].PAN) });
            } else if (SharerBY && SharerBY.length > 0) {
              _.assign(details, { SharerBYPan: SharerBY[0].PAN });
            }
            // _.assign(details, { SharerBYPan : SharerBY[0].PAN && SharerBY[0].PAN.length > 10 ? self.commonFunction.decrypt(SharerBY[0].PAN) : SharerBY[0].PAN})
          }

          var CreatedByUser = _.filter(usersData, ["_id", details.CreatedBy]);
          _.assign(details, { EnterBY: (CreatedByUser[0] != null || CreatedByUser[0] != undefined) ? (CreatedByUser[0].FirstName + " " + CreatedByUser[0].LastName) : "" })

          var ModifiedByUser = _.filter(usersData, ["_id", details.ModifiedBy]);
          _.assign(details, { ModifiedBy: (ModifiedByUser[0] != null || ModifiedByUser[0] != undefined) ? (ModifiedByUser[0].FirstName + " " + ModifiedByUser[0].LastName) : "" })


          _.forEach(details.Recipients, function (RecipientsId) {

            // console.log('RecipientsId',RecipientsId.Name)
            let name = (RecipientsId.Name)
              ? `${RecipientsId.Name}`
              : `${RecipientsId.FirstName} ${RecipientsId.LastName}`
            name = `${name} ("PAN/Other"-${RecipientsId.UserType === "govevaUser" ? RecipientsId.PAN && RecipientsId.PAN.length > 10 ? self.commonFunction.decrypt(RecipientsId.PAN, 'Secret message') : RecipientsId.PAN : RecipientsId.Document_No})`
            recipientByName.push(name)
            // console.log('DUMP:', JSON.stringify(details.Recipients.Document_No, null, 2));
            // if (details.RecipientType == "nonGovevaUser") {
            //   var recipientName = _.filter(recipientData, ["_id", RecipientsId])
            //   recipientByName.push((recipientName[0] != null || recipientName[0] != undefined) ? recipientName[0].Name : "")
            // } else {
            //   var recipientName = _.filter(usersData, ["_id", RecipientsId])
            //   recipientByName.push((recipientName[0] != null || recipientName[0] != undefined) ? (recipientName[0].FirstName + " " + recipientName[0].LastName) : "")
            // }
          })
          _.assign(details, { recipientByName })


          detailsListData.push(details);
        })
        this.upsiDetails = detailsListData;
        
        if (this.isShowEncryptedPAN) {
          for (let i = 0; i < this.upsiDetails.length; i++) {
            for (let j = 0; j < this.upsiDetails[i].recipientByName.length; j++) {
              const match = this.upsiDetails[i].recipientByName[j].match(/-(\w+)/);
              const match1 = this.upsiDetails[i].SharerBYPan;
              if ((match != undefined || match1 != undefined)) {
                const encryptedPan = '**********';

                if (match && this.upsiDetails[i]?.recipientByName?.[j]) {
                  this.upsiDetails[i].recipientByName[j] = this.upsiDetails[i].recipientByName[j].replace(match[1], encryptedPan);
                }

                if (match1 && this.upsiDetails[i]?.SharerBYPan) {
                  this.upsiDetails[i].SharerBYPan = this.upsiDetails[i].SharerBYPan.replace(match1, encryptedPan);
                }
              } else {
                this.upsiDetails[i].recipientByName[j];
                this.upsiDetails[i].SharerBYPan;
              }
            }
          }
        }
        else {
          for (let i = 0; i < this.upsiDetails.length; i++) {
            for (let j = 0; j < this.upsiDetails[i].recipientByName.length; j++) {
              this.upsiDetails[i].recipientByName[j];
              this.upsiDetails[i].SharerBYPan;
            }
          }
        }
        if (this.isMakerCheckerUsed) {
          if (!this.isShowUnapproved) {
            this.upsiDetails = this.upsiDetails.filter((detail) => {
              if (detail.IsCheckerApproved == null || detail.IsCheckerApproved == undefined) {
                return true
              } else {
                if (detail.IsCheckerApproved) {
                  return true
                } else {
                  return false
                }
              }
            });
          } else {
            this.upsiDetails = this.upsiDetails.filter((detail) => {
              if (detail.IsCheckerApproved == null || detail.IsCheckerApproved == undefined) {
                return false
              } else {
                if (detail.IsCheckerApproved) {
                  return false
                } else {
                  return true
                }
              }
            });
          }
        }
        
        // Check which records have been emailed (after all filtering is done)
        // this.checkEmailedRecords();
        
        // if (this.dtElement && this.dtElement.dtInstance) {
        //   this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        //     dtInstance.destroy();
        //     setTimeout(() => {
        //       this.dtUpsiDetailsTrigger.next(); // ensure table is re-rendered
        //     }, 0);
        //   });
        // } else {
        //   setTimeout(() => {
        //     this.dtUpsiDetailsTrigger.next();
        //   }, 0);
        // }
      });

    //    if (this.dtElement && this.dtElement.dtInstance) {
    //   this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //     dtInstance.destroy();
    //     this.dtUpsiDetailsTrigger.next(); // re-render after destroy
    //   });
    // } else {
    //   this.dtUpsiDetailsTrigger.next(); // first render
    // }
  }

  toggleSelectAll(event: Event) {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      this.selectedIds = this.upsiDetails.map(details => details._id);
    } else {
      this.selectedIds = [];
    }
    // console.log("selectedIds", this.selectedIds)
  }

  toggleSelection(id: string) {
    const index = this.selectedIds.indexOf(id);
    if (index === -1) {
      this.selectedIds.push(id);
    } else {
      this.selectedIds.splice(index, 1);
    }
    // console.log("selectedIds", this.selectedIds)
  }

  isSelected(id: string): boolean {
    return this.selectedIds.includes(id);
  }

  performActionOpen() {
    // console.log("Selected Items:", this.selectedIds);
    const obj = { "upsiDetailsIds": this.selectedIds, 'isHidden': false }
    this.uPSIDatailsService.statusClosed(obj).subscribe((response) => {
      if (response.status === 0) {
        this.alert.success("Status open successfully!");
        this.getDetailsList({});
      }
    });
  }
  performAction() {
    // console.log("Selected Items:", this.selectedIds);
    const obj = { "upsiDetailsIds": this.selectedIds, 'isHidden': true }
    this.uPSIDatailsService.statusClosed(obj).subscribe((response) => {
      if (response.status === 0) {
        this.alert.success("Status closed successfully!");
        this.getDetailsList({});
      }
    });
  }

  approveUSPIDetail(details) {

    var user_local = JSON.parse(localStorage.getItem("user"));
    var roles = user_local.Roles
    var SYSTEM_DEFINED_UPSI_CHECKER = roles.filter(role => { return role.RoleName == "SYSTEM_DEFINED_UPSI_CHECKER" || role.RoleName == "Admin" || role.RoleName == "Trial" });

    if (SYSTEM_DEFINED_UPSI_CHECKER.length <= 0) {
      alert("Need SYSTEM_DEFINED_UPSI_CHECKER Role to approve!");
      return;
    }
    details.IsCheckerApproved = true;
    this.uPSIDatailsService.addUPSI(details).subscribe(response => {
      if (!response.status) {
        alert("UPSI Deatils approved");
      } else {
        alert("UPSI Deatils approval failed !");

      }
    })
  }
  editUpsiDetails(detailsId) {
    if (this.isMakerCheckerUsed) {
      var user_local = JSON.parse(localStorage.getItem("user"));
      var roles = user_local.Roles
      var SYSTEM_DEFINED_UPSI_CHECKER = roles.filter(role => { return role.RoleName == "SYSTEM_DEFINED_UPSI_CHECKER" || role.RoleName == "Admin" || role.RoleName == "Trial" });

      if (SYSTEM_DEFINED_UPSI_CHECKER.length <= 0) {
        alert("Need SYSTEM_DEFINED_UPSI_CHECKER Role to approve!");
        return;
      }
    }
    this.router.navigate([{ outlets: { 'structure-outlet': ['userMaster', 'upsidetails', 'upsidetailsadd', 'edit', detailsId] } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['/details/edit/', detailsId]);
  }


  historyDetailsById(detailsId) {


    let usersList = this.taskService.getUsersList();

    let hisList = this.detailsService.getDetailsHistory(detailsId);
    var upsiDetail = this.upsiDetails.filter(detail => { return detail._id == detailsId });
    var emailAttachentToBeAddedInHistory = [];
    var createdByNameUser = "";
    var EmailText = "";
    var EmailSubject = "";
    if (upsiDetail) {
      emailAttachentToBeAddedInHistory = upsiDetail[0].FileNameUqEmail;
      emailAttachentToBeAddedInHistory = emailAttachentToBeAddedInHistory.map(emailAt => { return this.commonFunction.returnFilenameAfterfirstHypen(emailAt) });
      createdByNameUser = upsiDetail[0].EnterBY;
      EmailText = upsiDetail[0].EmailText;
      EmailSubject = upsiDetail[0].EmailSubject;
    }

    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    var paramData2 = {
      companyID: companyDetails.companyID
    }

    let sharerList = this.sharerService.getSharerList(paramData2);

    let recipientList = this.sharerService.getRecipientList(paramData2);

    var NatureofUPSIList = this.ItemList

    Observable.forkJoin([hisList, usersList, sharerList, recipientList])
      .subscribe((response: any) => {
        var HistoryData;
        if (response[0].status == 0) {
          HistoryData = response[0].data
        } else {
          HistoryData = {};
        }
        var usersData;
        if (response[1].status == 0) {
          usersData = response[1].result;
        } else {
          usersData = {};
        }

        var sharerData;
        if (response[2].status == 0) {
          sharerData = response[2].data;
        } else {
          sharerData = {};
        }

        var recipientData;
        if (response[3].status == 0) {
          recipientData = response[3].data;
        } else {
          recipientData = {};
        }

        var detailsHisData = [];
        _.forEach(HistoryData, function (History) {
          var recipientByName = []

          if (History.d.SharerType == "nonGovevaUser") {
            var SharerBY = _.filter(sharerData, ["_id", History.d.SharerId]);
            _.assign(History, { SharerBYName: (SharerBY[0] != null || SharerBY[0] != undefined) ? SharerBY[0].Name : "" })
          } else {
            var SharerBY = _.filter(usersData, ["_id", History.d.SharerId]);
            _.assign(History, { SharerBYName: (SharerBY[0] != null || SharerBY[0] != undefined) ? (SharerBY[0].FirstName + " " + SharerBY[0].LastName) : "" })


          }

          var ModifiedByUser = _.filter(usersData, ["_id", History.d.ModifiedBy]);
          _.assign(History, { ModifiedBy: (ModifiedByUser[0] != null || ModifiedByUser[0] != undefined) ? (ModifiedByUser[0].FirstName + " " + ModifiedByUser[0].LastName) : "" })


          var CreatedByUser = _.filter(usersData, ["_id", History.d.CreatedBy]);
          _.assign(History, { CreatedByUserName: (CreatedByUser[0] != null || CreatedByUser[0] != undefined) ? (CreatedByUser[0].FirstName + " " + CreatedByUser[0].LastName) : "" })

          var NatureofUPSIItem = _.filter(NatureofUPSIList, ["_id", History.d.NatureofUPSI])
          _.assign(History, { NatureofUPSI: (NatureofUPSIItem[0] != null || NatureofUPSIItem[0] != undefined) ? NatureofUPSIItem[0].Item : "" })

          _.forEach(History.d.Recipients, function (RecipientsId) {

            recipientByName.push((RecipientsId.Name) ? RecipientsId.Name : (RecipientsId.FirstName + " " + RecipientsId.LastName))

            // if (History.d.RecipientType == "nonGovevaUser") {
            //   var recipientName = _.filter(recipientData, ["_id", RecipientsId])
            //   recipientByName.push((recipientName[0] != null || recipientName[0] != undefined) ? recipientName[0].Name : "")
            // } else {

            //   var recipientName = _.filter(usersData, ["_id", RecipientsId])
            //   recipientByName.push((recipientName[0] != null || recipientName[0] != undefined) ? (recipientName[0].FirstName + " " + recipientName[0].LastName) : "")

            // }
          })
          _.assign(History, { recipientByName })

          detailsHisData.push(History);

        })

        detailsHisData = detailsHisData.filter(function (x) {
          return (x.d.IPAddress != '' && x.d.IPAddress != null)

        })

        detailsHisData = detailsHisData.filter(function (x) {
          return (_.size(x.d.Recipients) > 0)

        })
        //adding email, file, creator data in history
        for (var x = 0; x < detailsHisData.length; x++) {
          var filename = detailsHisData[x].d.FileOriginalName;
          filename = filename ? filename.map(file => { return this.commonFunction.returnFilenameAfterfirstHypen(file) }) : filename
          detailsHisData[x].d.backendFileName = filename.join(", ");
          detailsHisData[x].d.FileNameUqEmail = emailAttachentToBeAddedInHistory.join(", ");
          detailsHisData[x].CreatedByUserName = createdByNameUser;
          detailsHisData[x].d.EmailText = EmailText;
          detailsHisData[x].d.EmailSubject = EmailSubject;
        }






        $("#Historytable").DataTable().destroy();
        this.detailsHistory = detailsHisData;



        this.dtDetailsTrigger.next();
        $('#historyModel').modal('show');
      });




  }

  searchData() {

    // console.log('hiii')
    if (this.entrydate == null && this.Item == '' && this.EnteredBy == '' && this.Updatedby == '' && this.upsidate == null && this.upsidateto == null && this.shareddate == null &&
      this.Recipient == '' && this.sharerBy == '' && this.sharerType == null && this.receipientType == null && this.shareddateTo == null && this.entrydateTo == null && this.UPSIDetailsListSearchMode == null
      && !this.isShowUnapproved) {
      this.alert.success("Enter  one of search data.");
      return;

    }


    var paramData = {
      CreatedBy: (this.EnteredBy != null && this.EnteredBy.trim() != '' && _.size(this.EnteredBy.trim())) ? this.EnteredBy.trim() : null,
      CreatedDate: (this.entrydate != null && this.entrydate != '' && _.size(this.entrydate)) ? this.setDate(this.entrydate) : null,
      CreatedDateTo: (this.entrydateTo != null && this.entrydateTo != '' && _.size(this.entrydateTo)) ? this.setDate(this.entrydateTo) : null,
      ModifiedBy: (this.Updatedby != null && this.Updatedby.trim() != '' && _.size(this.Updatedby.trim())) ? this.Updatedby.trim() : null,
      PublicDate: (this.upsidate != null && this.upsidate != '' && _.size(this.upsidate)) ? this.setDate(this.upsidate) : null,
      PublicDateTo: (this.upsidateto != null && this.upsidateto != '' && _.size(this.upsidateto)) ? this.setDate(this.upsidateto) : null,
      SharedDate: (this.shareddate != null && this.shareddate != '' && _.size(this.shareddate)) ? this.setDate(this.shareddate) : null,
      SharedDateTo: (this.shareddateTo != null && this.shareddateTo != '' && _.size(this.shareddateTo)) ? this.setDate(this.shareddateTo) : null,
      SharerType: (this.sharerType != null && this.sharerType.trim() != '' && _.size(this.sharerType.trim())) ? this.sharerType.trim() : null,
      RecipientType: (this.receipientType != null && this.receipientType.trim() != '' && _.size(this.receipientType.trim())) ? this.receipientType.trim() : null,
      SharerId: (this.sharerBy != null && this.sharerBy.trim() != '' && _.size(this.sharerBy.trim())) ? this.sharerBy.trim() : null,
      Recipients: (this.Recipient != null && this.Recipient.trim() != '' && _.size(this.Recipient.trim())) ? this.Recipient.trim() : null,
      NatureofUPSI: (this.Item != null && this.Item.trim() != '' && _.size(this.Item.trim())) ? this.Item.trim() : null,
      SearchMode: this.UPSIDetailsListSearchMode,
    }

    var compacted = _.pickBy(paramData);
    this.getDetailsList(compacted)


  }

  clear() {

    this.entrydate = null;
    this.isShowUnapproved = false;
    this.isShowEncryptedPAN = false;
    this.EnteredBy = '';
    this.Item = '';
    this.upsidateto = null;
    this.Updatedby = '';
    this.upsidate = null;
    this.shareddate = null
    this.shareddateTo = null;
    this.entrydateTo = null;

    this.Recipient = '';
    this.sharerBy = '';
    this.sharerType = null;
    this.receipientType = null;
    this.getDetailsList({})

  }
  deleteDetailsByIdModel(detailsId) {
    this.detailsIdforDelete = detailsId;
    $('#deleteDetailsConfirmation').modal('show');
  }

  deleteDetailsById() {

    new Promise(resolve => this.detailsService.deleteDetails(this.detailsIdforDelete).subscribe((response) => {
      if (response.status == 1) {
        this.alert.error(response.message);
      } else {
        this.getDetailsList({});
        this.alert.success(response.message);

      }

    }))

  }


  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  //setUPSIDetailsListSearchMode
  setUPSIDetailsListSearchMode(mode) {
    this.UPSIDetailsListSearchMode = mode;

    if (mode != "public") {// Disabling Public Dates if Search Mode is changed to Mode other than public
      this.upsidateto = undefined;
      this.upsidate = undefined;
    }

  }

  sharerList(typeOfUser) {

    this.sharerBy = '';
    this.sharerType = typeOfUser;

  }

  recipientList(typeOfUser) {
    this.Recipient = '';
    this.receipientType = typeOfUser

  }


  ViewEmailLog(_id) {

    const modelRef = this.modalService.open(UpsiemaillogdetailsComponent, {
      size: 'lg',
      windowClass: 'EmailModel'
    })
    modelRef.componentInstance._id = _id;
    modelRef.result.then(response => {
      this.alert.success(response.message)
    }, error => {

    })

  }

  openEmailDownloadModal(files) {
    files = files.map(file => { return { name: this.commonFunction.returnFilenameAfterfirstHypen(file), backendName: file } });
    this.fileNameArray = files
    $("#UpsiFileDownloadTitle").html("Attachments of Emails");
    $("#upsiDetailsEmailFileDownloadDialog").modal('toggle');
  }

  openDownloadModal(files) {
    files = files.map(file => { return { name: this.commonFunction.returnFilenameAfterfirstHypen(file), backendName: file } });
    this.fileNameArray = files
    $("#UpsiFileDownloadTitle").html("Attachments of Emails");
    $("#upsiDetailsFileDownloadDialog").modal('toggle');
  }

  downloadFileEmail(fileName) {

    var token = localStorage.getItem('token')
    window.location.href = this.downloadURLForUPSIEmail + fileName + '/' + token;
  }

  downloadDocumentFile(id) {
    var token = localStorage.getItem('token')
    window.location.href = this.downloadURLForUPSI + id + '/' + token;
  }
  downloadFileBase(fileName) {
    var token = localStorage.getItem('token')
    // console.log('downloadURLForUPSIBase', this.downloadURLForUPSIBase)
    window.location.href = this.downloadURLForUPSIBase + fileName + '/' + token;
  }


  //This Method if for selecting Columns for Excel and PDF Export
  //ev is the event of the checkbox
  //id is the index of the column that is to be added in exportOptions
  //id start from Zero
  selectUnselectColumn(ev, id) {



    //Reading from the current state
    let UpsiListingColumns = [...this.dtUpsiDetails.buttons[0].exportOptions.columns];


    if (ev.target.checked) {
      //add it to this.dtUpsiDetails.BUttons[].exportOptions.columns

      if (UpsiListingColumns.filter(i => i == id).length == 0) {
        UpsiListingColumns.push(id);
      }

    } else {
      //remove it from this.dtUpsiDetails.BUttons[].exportOptions.columns

      UpsiListingColumns = UpsiListingColumns.filter(i => i != id);

    }

    //Reordering of columns is important on an event of multiple select and unselect of same column
    let UpsiExportReorder = []
    for (let x = 0; x < this.UPSIListexportColumnOrignalOrder.length; x++) {
      if (UpsiListingColumns.includes(this.UPSIListexportColumnOrignalOrder[x])) {
        UpsiExportReorder.push(this.UPSIListexportColumnOrignalOrder[x]);
      }
    }
    //Reorderig completed


    //Setting to the current state:
    this.dtUpsiDetails.buttons[0].exportOptions.columns = [...UpsiExportReorder];
    this.dtUpsiDetails.buttons[1].exportOptions.columns = [...UpsiExportReorder];

    return;
    //$("#selectedUPSIUserShared").click();
  }

  checkEmailedRecords() {
    if (!this.upsiDetails || this.upsiDetails.length === 0) {
      return;
    }

    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    const emailCheckPromises = this.upsiDetails.map(detail => {
      const params = {
        companyID: companyDetails.companyID,
        _id: detail._id,
      };
      
      return this.emailsLogService.getEmailsLog(params).toPromise().then((emails: any) => {
        // Check if email logs exist and have data
        detail.isEmailed = emails && emails.data && emails.data.length > 0;
        return detail;
      }).catch((error) => {
        // If error, assume not emailed
        detail.isEmailed = false;
        return detail;
      });
    });

    Promise.all(emailCheckPromises).then(() => {
      // All email checks completed, trigger change detection
      this.cdRef.detectChanges();
    });
  }

  sendUpsiDetailsMail(details, ev) {
    ev.stopPropagation();
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
    const params = {
      companyID: companyDetails._id,
      _id: details._id,
    };

    this.emailsLogService.getEmailsLog(params).subscribe((emails) => {
      // Use email logs if available, otherwise use details data directly
      var emailLogs = (emails && emails.data && emails.data.length > 0) ? emails.data[0] : null;
      
      const UPSIDetailObject = {
        SharerId: details.SharerId,
        Recipients: details.Recipients,
        SharerType: details.SharerType,
        RecipientType: details.RecipientType,
        TypeOfShared: details.TypeOfShared,
        SharedDate: details.SharedDate,
        SharedTime: details.SharedTime,
        PublicDate: details.PublicDate,
        PublicTime: details.PublicTime,
        CreatedBy: details.CreatedBy,
        IPAddress: details.IPAddress,
        CompanyId: details.CompanyId,
        EmailText: emailLogs ? emailLogs.EmailText : (details.EmailText || ''),
        EmailSubject: emailLogs ? emailLogs.Subject : (details.EmailSubject || ''),
        NatureofUPSI: details.NatureText || details.NatureofUPSI?.Item || '',
        FileNameUqEmail: details.FileNameUqEmail || [],
        OtherNatureOfUPSI: details.OtherNatureOfUPSI || '',
        DateOfInitiation: details.DateOfInitiation,
        PublicStatus: details.PublicStatus || '',
      };
      
      this.uPSIDatailsService.sendUPSIDetailsEmail(UPSIDetailObject).subscribe((response) => {
        if (response.status === 0) {
          this.alert.success("Email has been sent successfully!");
          // Refresh the list to update the highlighted status
          this.getDetailsList({});
        } else {
          this.alert.error("Failed to send email. Please try again.");
          console.error("Email send failed:", response);
        }
      }, (error) => {
        this.alert.error("Error sending email. Please check your connection.");
        console.error("Email send error:", error);
      });
    }, (error) => {
      // If fetching email logs fails, use details data directly
      console.warn("Could not fetch email logs, using details data:", error);
      
      const UPSIDetailObject = {
        SharerId: details.SharerId,
        Recipients: details.Recipients,
        SharerType: details.SharerType,
        RecipientType: details.RecipientType,
        TypeOfShared: details.TypeOfShared,
        SharedDate: details.SharedDate,
        SharedTime: details.SharedTime,
        PublicDate: details.PublicDate,
        PublicTime: details.PublicTime,
        CreatedBy: details.CreatedBy,
        IPAddress: details.IPAddress,
        CompanyId: details.CompanyId,
        EmailText: details.EmailText || '',
        EmailSubject: details.EmailSubject || '',
        NatureofUPSI: details.NatureText || details.NatureofUPSI?.Item || '',
        FileNameUqEmail: details.FileNameUqEmail || [],
        OtherNatureOfUPSI: details.OtherNatureOfUPSI || '',
        DateOfInitiation: details.DateOfInitiation,
        PublicStatus: details.PublicStatus || '',
      };
      
      this.uPSIDatailsService.sendUPSIDetailsEmail(UPSIDetailObject).subscribe((response) => {
        if (response.status === 0) {
          this.alert.success("Email has been sent successfully!");
          this.getDetailsList({});
        } else {
          this.alert.error("Failed to send email. Please try again.");
          console.error("Email send failed:", response);
        }
      }, (error) => {
        this.alert.error("Error sending email. Please check your connection.");
        console.error("Email send error:", error);
      });
    });
  }

}